import { Text } from '@thefarmersfront/kitchen';

/**
 * 공통 필터 호출 에러 메시지 렌더링 함수
 */
export const renderFilterErrorMessage = () => (
  <>
    <Text size="large" color="white">
      필터 정보 호출 요청에 실패했습니다.
    </Text>
    <Text size="large" color="white">
      페이지{' '}
      <Text element="span" size="large" weight="semi-bold" color="white">
        새로고침
      </Text>
      을 시도해주세요.
    </Text>
  </>
);
